module.exports = __webpack_public_path__ + "static/brochure-icon-0156b444df4f0db9d8a66b3e7e319fd7.png";